import React from "react";
import axios from "axios";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";

import Typography from "@mui/material/Typography";

import ProfileSecurityPaper from "./ProfileSecurityPaper";
import ShadowPaper from "./../UtilityComponents/PaperUtilityComponents/ShadowPaper";
import ProfileRequiredPaper from "./ProfileRequiredPaper";

import ConfirmDialogProps from "../../NavigationComponents/ConfirmDialogProps";

import GetCSRFToken from "../../AuthComponents/GetCSRFToken";
import FormRowState from "../UtilityComponents/FormUtilityComponents/FormRowState";
import FormConfig from "../UtilityComponents/FormUtilityComponents/FormConfig";
import { isMobile } from "react-device-detect";

type ProfilePanelProps = {
  setConfirmOnNavigateAway: (confirmOnNavigateAway: Partial<ConfirmDialogProps> | false) => void;
  emailVerified: boolean;
  backendInputRowStateList?: FormRowState[];
  setBackendInputRowStateList: (backendInputRowStateList: FormRowState[] | undefined) => void;
  profileConfig: FormConfig | undefined;
  inputRowStateList: FormRowState[];
  setInputRowStateList: (newState: FormRowState[] | ((oldState: FormRowState[]) => FormRowState[])) => void;
  handleUpdateNotification: () => void;
  userFullName: string | undefined;
};

const paperPadding = 2;

function ProfilePanel(props: ProfilePanelProps) {
  const theme = useTheme();
  const fixedSizeForSideSquares = theme.spacing(50);

  return (
    <Stack
      sx={{
        display: "flex",
        height: isMobile ? null : "100%",
        width: "100%",
        flexDirection: { xs: "column", lg: "row" },
        gap: 2,
        justifyContent: "center",
      }}
    >
      <Paper
        sx={{
          padding: paperPadding,
          flexGrow: 1,
          maxWidth: "1000px",
          height: "100%",
        }}
      >
        <ProfileRequiredPaper
          setConfirmOnNavigateAway={props.setConfirmOnNavigateAway}
          backendInputRowStateList={props.backendInputRowStateList}
          setBackendInputRowStateList={props.setBackendInputRowStateList}
          profileConfig={props.profileConfig}
          inputRowStateList={props.inputRowStateList}
          setInputRowStateList={props.setInputRowStateList}
          handleUpdateNotification={props.handleUpdateNotification}
        />
      </Paper>
      <Stack
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          gap: 2,
          width: { xs: "100%", lg: fixedSizeForSideSquares },
        }}
      >
        <ShadowPaper
          padding={2}
          locked={!props.emailVerified}
          unlockButtonText="Verify Email to Access Account Settings"
          handleUnlock={() => {
            axios
              .get("/api/user/verify-email/start", {
                headers: { "X-CSRFToken": GetCSRFToken() },
              })
              .then((res) => {})
              .catch((err) => {
                if (process.env.NODE_ENV === "development") {
                  console.log(err);
                } // TODO: handle failed verify email start (including already verified, maybe don't even allow this button to be clicked?)
              });
            window.open("/verify-email", "_blank", "noreferrer");
          }}
        >
          <ProfileSecurityPaper locked={!props.emailVerified} />
        </ShadowPaper>
        <Paper
          sx={{
            padding: paperPadding,
          }}
        >
          <Typography variant="h5" noWrap sx={{ color: "info.main", alignSelf: "flex-start" }}>
            Questions or Feedback
          </Typography>
          <a
            href={"mailto:contact@usesalus.com?subject=[Site Inquiry] " + (props.userFullName || "New User")}
            target="_blank"
            rel="noreferrer"
          >
            Email
          </a>{" "}
          us
        </Paper>
      </Stack>
    </Stack>
  );
}

export default ProfilePanel;
